import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/crm',
        name: 'crm',
        component: () => import('@/views/crm/base.vue'),
        remark: "CRM模块",
        children: [
            {
                path: 'register',
                name: 'register',
                component: () => import('@/views/crm/register.vue'),
                remark: "注册页面",
                meta: {
                    title: 'register'
                }
            },
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const { token, userId } = to.query;
    if (token) {
        sessionStorage.setItem('token', token)
    }
    if (userId) {
        sessionStorage.setItem('userId', userId)
    }
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

export default router
